/** 微店直采关联 / 采购退货地址保存前的说明文案 */

export const MSG_RELATIVE_MODIFY_RETURN_TIP =
  '修改关联如果更换上家的商品，新订单仍旧会是寄回当前已绑定的上家退货地址，直到新订单重新绑定新上家的退货地址后，新上家的退货地址才生效，订单退货地址是以下单时生效的退货地址为准，重新绑定上家退货地址不会对旧的订单生效'

export const MSG_RETURN_ADDRESS_SAVE_TIP =
  '订单退货地址是以下单时生效的退货地址为准，修改退货地址成功后只对新订单有效，老订单依旧是退回上家退货地址或微店默认退货地址'
